import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-bee-surprized-note',
  templateUrl: './bee-surprized-note.component.html',
  styleUrl: './bee-surprized-note.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BeeSurprizedNoteComponent {
  dataNotice;
  @Input() set data(value) {
    if (!value) {
      this.dataNotice = {
        title_1: { text: 'generic.error' },
        title_2: { text: 'registration.validation.error-common' },
      };
    } else {
      this.dataNotice = value;
    }
  }
  @Input() fullHeight = true;
}
